<template>
  <b-navbar :variant="variant" :type="type" toggleable="md">
    <b-container>
      <b-navbar-brand>
        <router-link to="/">
          <img src="@/assets/img/brand-logo.svg" />
        </router-link>
      </b-navbar-brand>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    variant: {
      default: "",
      type: String,
    },
    type: {
      default: "",
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
@import "../../node_modules/bootstrap/scss/functions";
@import "../../node_modules/bootstrap/scss/variables";
@import "../../node_modules/bootstrap/scss/mixins/breakpoints";

.navbar {
  position: absolute;
  width: 100%;
  z-index: 100;

  @include media-breakpoint-up(md) {
    padding-left: 0;
    padding-right: 0;
  }

  background-color: #ffffff;
  box-shadow: 0 2px 2px 0 rgba(20, 20, 20, 0.25);
  transition: all 200ms ease;
  transition-delay: 100ms;

  a {
    color: $navbar-color;
  }
}

.navbar-brand {
  img {
    width: 217px;

    @include media-breakpoint-up(md) {
      width: 271px;
    }
  }
}

.btn {
  background-color: #141414;
  border-color: #141414;
  font-weight: light;
  font-size: em(12);

  @include media-breakpoint-up(md) {
    font-size: em(14);
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue